import { createElement } from 'react';

import { view } from './LocalizedValueField.less';

const LocalizedValueField = ({ editing, input, localeMessage, viewStyle = {}, ...other }) =>
  createElement('div', { className: view, style: viewStyle }, localeMessage(input.value));

export default LocalizedValueField;
